import React, { useState,useEffect } from 'react'
import { getAllPlans, getAllmerchantsData, getSubscriptions } from '../../utils/firebase/firestore'
import { Typography } from '@mui/material';
import { mainColor } from '../../constants';
import PlansTable from '../../components/Tables/PlansTable';
import CustomButton from '../../components/CustomButton';
import { useNavigate } from 'react-router-dom';
import SkeletonTable from '../../components/Loaders/SkeletonTable';


const PlansPage = () => {
  const [rows,setRows]=useState([]);
  const [search,setSearch]=React.useState("");
  const [isloading,setLoading]=useState(false);
  const navigate=useNavigate()
  const columns = [
  // { id: "count", label: "#", minWidth: 100,align: "left", },
  { id: "title", label: "Title", minWidth: 100,align: "left", },
  { id: "hours", label: "Hours", minWidth: 100,align: "left", },
//   { id: "hours", label: "Minutes", minWidth: 100,align: "left", },
  { id: "price",
   label: "Price",
   minWidth: 100,align: "left",
   format: (value) => "$"+value },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
    align: "left",
  },
  //value.toLocaleString('en-US')
  // {
  //   id: "email",
  //   label: "Email",
  //   minWidth: 100,
  //   align: "left",
  // },
  {
    id: "control",
    label: "Enable/Disable",
    minWidth: 100,
    align: "left",

  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "left",
  },
];
const formatRows = (input) => {
    let list=[];
    for(let item of input){
      const {name,minutes,pricePlan:price,hour:hours,title,status,id}=item;
      list.push({name,minutes,hours,status,price,status,title,id})
    }
    const compare=(a,b)=>b.price-a.price
    list =list.sort(compare);
    setRows(list);
  }
  useEffect(() => {
   (async()=>{
    const list=await getAllPlans();

    //  console.log(list.filter(row => (
    //    row.title.toLowerCase().match(new RegExp(search.toLowerCase().trim())) ||
    //    row.status.toLowerCase().match(new RegExp(search.toLowerCase().trim()))
    //  )),"plans")
    formatRows(list)
   }
    )()
  
    
  }, [])
  
  return (
    <div style={{
      display:"flex",
      justifyContent:"center",
      flexDirection:"column",
      alignItems:"center",
      // height:"100vh",
      width:"100%",
      
      marginTop:30
    }}>
        <div style={{
            width:"90%",
            display:"flex",
            alignItems:"center",
            justifyContent:"space-between",
            margin:"10px 0px"
        }}>
            <Typography variant="h6" style={{fontSize:30}}>Plans</Typography>
            <CustomButton bg={mainColor} buttonText={"Add new plan"} onClick={()=>navigate("/plans/new")} />
        </div>
      {rows.length>0?<PlansTable 
        handleChange={setLoading}
        loading={isloading}
        setSearch={setSearch}
        rows={rows.filter(row=>(
          row.title.toLowerCase().match(new RegExp(search.toLowerCase().trim()))||
          row.status.toLowerCase().match(new RegExp(search.toLowerCase().trim()))
          ))}
        columns={columns}  />:
        <div style={{
          width:"90%"
        }}>
              <SkeletonTable loading/>
        </div>
        }
    </div>
  )
}

export default PlansPage